import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import your translation files
import translationEN from './en/translation.json';
import translationNL from './nl/translation.json';

// The translations
const resources = {
  en: {
    translation: translationEN
  },
  'en-US': {
    translation: translationEN
  },
  nl: {
    translation: translationNL
  },

};

i18n
  // detect user language
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next
  .use(initReactI18next)
  // init i18next
  .init({
    resources: resources as any, // Ensure proper typing for resources
    fallbackLng: {
      'en-US': ['en'],
      'en-GB': ['en'],
      'en-CA': ['en'],
      default: ['en']
    },
    debug: true,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    detection: {
      // Order of detection methods
      order: ['navigator', 'htmlTag', 'path', 'subdomain', 'cookie', 'localStorage'],

      // Cache user language preference
      caches: ['localStorage', 'cookie'],

      // Look for query parameter ?lng=LANGUAGE
      lookupQuerystring: 'lng',

      // Look for language in path (/en/page)
      lookupFromPathIndex: 0,
    },
    load: 'languageOnly'
  });

export default i18n;
